var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA11YmenuPieChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1774_10567)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.3999 2.63297C4.69993 2.93143 2.5999 5.22048 2.5999 8.00001C2.5999 10.9823 5.01756 13.4 7.9999 13.4C10.7794 13.4 13.0685 11.3 13.3669 8.60001H7.9999C7.66853 8.60001 7.3999 8.33138 7.3999 8.00001V2.63297ZM8.5999 2.63297V7.40001H13.3669C13.0903 4.89704 11.1029 2.90966 8.5999 2.63297ZM1.3999 8.00001C1.3999 4.35493 4.35482 1.40001 7.9999 1.40001C11.645 1.40001 14.5999 4.35493 14.5999 8.00001C14.5999 11.6451 11.645 14.6 7.9999 14.6C4.35482 14.6 1.3999 11.6451 1.3999 8.00001Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1774_10567"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA11YmenuPieChart);
export default __webpack_public_path__ + "static/media/a11ymenu_pie_chart.054719fe43ead7163c10895113e764aa.svg";
export { ForwardRef as ReactComponent };